<template>
	<div
		v-if="hasPrice && priceInfo.PriceWithoutTax !== null"
		class="price-holder">
		<div class="grid grid--1-2" v-if="!inclTaxOnly">
			<div class="cell price-holder__cell">
				<p class="price-holder__price--btw">(excl.&nbsp;BTW)</p>
			</div>
			<div class="cell price-holder__cell">
				<p
					class="price-holder__price-large">
					<template v-if="!getOrderLine.isRush">
						{{ formatPrice(priceInfo.PriceWithoutTax) }}
					</template>
					<template v-if="getOrderLine.isRush">
						{{ formatPrice(priceExtra.rushPrice) }}
					</template>
				</p>
			</div>
		</div>
		<div
			class="grid grid--1-2"
			v-if="inclTaxOnly || (!getOrderLine.isRush && !getOrderLine.isOffset)">
			<div class="cell price-holder__cell">
				<p class="price-holder__price--btw" v-if="!inclTaxOnly">(incl.&nbsp;BTW)</p>
			</div>
			<div class="cell price-holder__cell">
				<p
					:class="inclTaxOnly ? 'price-holder__price-large' : 'price-holder__price'">
					<template v-if="inclTaxOnly && getOrderLine.isRush && priceExtra.rushPriceWithTax">
						{{ formatPrice(priceExtra.rushPriceWithTax) }}
					</template>
					<template v-else>
						{{ formatPrice(priceInfo.PriceWithTax) }}
					</template>
				</p>
			</div>
		</div>

		<p
			class="price-holder__price price-holder__price--red"
			v-if="getOrderLine.isOffset">offset
		</p>
		<p
			class="price-holder__price price-holder__price--red"
			v-if="getOrderLine.isRush">spoedlevering
		</p>

	</div>
</template>

<script>
import { Helper } from "@/helpers";

export default {
	name: "Price",
	props: {
		overview: {
			type: Boolean,
			default: false
		},
		smaller: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		hasPrice () {
			return this.$store.getters.getPrice.PriceWithoutTax != null;
		},
		inclTaxOnly () {
			// data-prices-incl-tax-only="true" on the mount div hides the
			// (excl. BTW) row and promotes the (incl. BTW) value to large
			// styling. SDW opts in; DWN omits the attribute.
			return this.$store.state.baseProps.pricesInclTaxOnly === "true";
		},
		priceInfo () {
			return this.$store.getters.getPrice;
		},
		priceExtra () {
			return this.$store.getters.getPriceExtra;
		},
		currentStep () {
			return this.$store.getters.getCurrentStep.data.name;
		},
		getOrderLine () {
			return this.$store.getters.getOrderLine;
		}
	},
	methods: {
		formatPrice (price) {
			if (price) {
				return Helper.toCurrencyString(price);
			}
		}
	}
};
</script>

<style lang="scss">
.price-holder__cell {
	display: flex;
	justify-content: flex-start;
	padding-right: 8px;
	max-width: 45% !important;
}

.price-holder__price-large {
	font-size: 1.6rem;
	line-height: normal;
	font-weight: 700;
	letter-spacing: .15px;
	color: #1D2939;
}

.price-holder__price {
	font-size: 1.3rem;
	font-weight: 500;
	line-height: 1.5;
	color: #475467;
}

.price-holder__price--btw {
	font-size: 1rem;
	line-height: 1.5;
	font-weight: 500;
	color: #98A2B3;
}

</style>



// WEBPACK FOOTER //
// src/components/element/price.vue